module.exports = __webpack_public_path__ + "img/89-Staufereiche Kolonial - Chêne Dor‚.jpg";